import * as z from "zod";

export const getCustomEventNames = {
  name: "getCustomEventNames" as const,
  input: z.object({}),
  output: z.object({ eventNames: z.array(z.string()) }),
};
